import React from 'react';
import Loader from '../../generic/Loader';
import ArtifactLibrary from './ArtifactLibrary';

export const ArtifactListView = ({
  artifacts = [],
  controls = false,
  ready = true,
  exhibitionId,
  showInFolders,
}) => (
  <div className="artifact-list-wrapper">
    <div className="artifact-list">
      <ArtifactLibrary
        showInFolders={showInFolders}
        artifacts={artifacts}
        controls={controls}
        exhibitionId={exhibitionId}
      />
    </div>
    {ready || <Loader inverted={false} />}
  </div>
);

const ArtifactList = ArtifactListView;

export default ArtifactList;
